import { Link } from "react-router-dom";

export default function LRCrossLink() {
  return (
    <section className="relative py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/763cf0ee3ad9cbbaa87ede95b1dc6494.jpg"
          alt="Cozy corner inspiration"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#FAF7F0]/80" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-8 md:px-16">
        <div className="max-w-xl">
          <p
            className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-5"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Also From the Journal
          </p>
          <h2
            className="text-[#2C2825] text-3xl md:text-4xl lg:text-5xl leading-tight mb-6"
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
          >
            Looking for smaller,<br />
            <em>quieter spaces?</em>
          </h2>
          <p
            className="text-[#6B5E53] text-sm md:text-base leading-relaxed mb-10 max-w-sm"
            style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
          >
            Explore cozy corners designed for reading, resting, and everyday calm.
          </p>
          <Link
            to="/cozy-corners"
            className="inline-flex items-center gap-2.5 bg-[#2C2825] text-[#FAF7F0] px-9 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#3A3632] transition-colors cursor-pointer whitespace-nowrap uppercase"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Visit Cozy Corners
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
